import { defineStore } from 'pinia'

import type { CategoryResponseInfo, TagDetail } from '@/types/api'
import { getTagDetail } from '@/service/tag'

export const useCategoryStore = defineStore('category', () => {
  const tagDetail = ref<Nullable<TagDetail>>(null)

  const categoryMap = reactive<Record<number, CategoryResponseInfo>>({})

  function setToCategoryMap(category: CategoryResponseInfo) {
    const cid = category.id

    if (cid) {
      categoryMap[cid] = category
    }
  }

  async function fetchTagDetail(tagId: number | string) {
    const { data } = await getTagDetail(tagId)
    tagDetail.value = data
    return data
  }

  return {
    categoryMap,
    setToCategoryMap,

    tagDetail,
    fetchTagDetail,
  }
})
